import * as React from 'react';
import WebGLTextOrientation from './WebGLTextOrientation';

export default class WebGLText {

	public constructor (private text: string | React.ReactElement<any>, private x: number, private y: number, private orientation: WebGLTextOrientation = WebGLTextOrientation.TOP_RIGHT, private pixelMargin = 0) {}

	public getText () {
		return this.text;
	}

	public getX () {
		return this.x;
	}

	public getY  () {
		return this.y;
	}

	public getOrientation () {
		return this.orientation;
	}

	public getPixelMargin () {
		return this.pixelMargin;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/WebGLText.ts